












































































































import Vue, { PropType } from 'vue';
import {
  LabelQualityGoal,
  QualityGoalType,
} from '../../interfaces/types/QualityGoal';
import Button from '../common/Button/Button.vue';
import ConfigureButton from '../common/Button/ConfigureButton.vue';

import SummaryReport from './QualityGoalReport/SummaryReport.vue';
import SyntaxErrorGoalReport from './QualityGoalReport/SyntaxErrorGoalReport.vue';
import TotalDataQuantityGoalReport from './QualityGoalReport/TotalDataQuantityGoalReport.vue';
import DistributionGoalReport from './QualityGoalReport/DistributionGoalReport.vue';
import QuantityGoalReport from './QualityGoalReport/QuantityGoalReport.vue';
import MinAvgMaxGoalReport from './QualityGoalReport/MinAvgMaxGoalReport.vue';
import ArrLenMinAvgMaxGoalReport from './QualityGoalReport/ArrLenMinAvgMaxGoalReport.vue';
import TotalElementCountReport from './QualityGoalReport/TotalElementCountReport.vue';

import { LabelsetType } from '@/interfaces/types/Labelset';
import {
  getLabelsetById,
  getAllLabelsetByWorkspaceId,
  setReportTimeline,
} from '@/utils/axiosInstances';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Modal from '../common/Modal/Modal.vue';
import CustomSelect from '../common/Select/CustomSelect.vue';
import DeleteButton from '../common/Button/DeleteButton.vue';

const numOfDefaultPage = 3;

export default Vue.extend({
  props: {
    qualityGoal: {
      type: Object as PropType<QualityGoalType>,
    },
  },
  data(): {
    labelset: Partial<LabelsetType>;
    currentLabelsetId: string;
    isSettingModalVisible: boolean;
    labelsetList: Partial<LabelsetType>[];
    prevTimelineNodeSettingKey: string;
    nextTimelineNodeSettingKey: string;
  } {
    return {
      labelset: {
        name: '',
        description: '',
      },
      currentLabelsetId: '',
      isSettingModalVisible: false,
      labelsetList: [],
      prevTimelineNodeSettingKey: '',
      nextTimelineNodeSettingKey: '',
    };
  },
  async created() {
    this.labelset = await getLabelsetById(this.$route.params.labelsetId);
  },
  computed: {
    localQualityGoal: {
      get(): QualityGoalType | undefined {
        return this.qualityGoal;
      },
      set(newVal: QualityGoalType | undefined) {
        return newVal;
      },
    },
    currentPageNum(): number {
      if (
        typeof this.$route.query.pageNum === 'string' &&
        parseInt(this.$route.query.pageNum)
      ) {
        const queryPageNum = parseInt(this.$route.query.pageNum);
        return Math.min(this.maxPageNum, Math.max(queryPageNum, 1));
      }
      return 1;
    },
    currentLabel(): LabelQualityGoal {
      return this.labelQualityGoalList[
        this.currentPageNum - numOfDefaultPage - 1
      ];
    },
    isSummary(): boolean {
      return this.currentPageNum === 1;
    },
    isSyntaxErrorGoal(): boolean {
      return this.currentPageNum === 2;
    },
    isTotalDataQuantityGoal(): boolean {
      return this.currentPageNum === 3;
    },
    isLabelGoal(): boolean {
      return this.currentPageNum > numOfDefaultPage;
    },
    isDistributionGoal(): boolean {
      return this.isLabelGoal && this.currentLabel.method === 'dist';
    },
    isQuantityGoal(): boolean {
      return this.isLabelGoal && this.currentLabel.method === 'classQuantity';
    },
    isMinAvgMaxGoal(): boolean {
      return this.isLabelGoal && this.currentLabel.method === 'minAvgMax';
    },
    isArrLenMinAvgMaxGoal(): boolean {
      return this.isLabelGoal && this.currentLabel.method === 'arrLenMinAvgMax';
    },
    isTotalElementCountGoal(): boolean {
      return this.isLabelGoal && this.currentLabel.method === 'arrElCnt';
    },
    labelQualityGoalList(): LabelQualityGoal[] {
      if (!this.localQualityGoal) return [];

      const labels = this.localQualityGoal.qualityGoal.labelQualityGoal;

      return Object.keys(labels).reduce((result: LabelQualityGoal[], key) => {
        if (labels[key].target !== undefined) result.push(labels[key]);
        return result;
      }, []);
    },
    maxPageNum(): number {
      return numOfDefaultPage + this.labelQualityGoalList.length;
    },
    /**
     * 타임라인 설정 시 사용할 설정 가능한 라벨셋 목록 배열(Select 컴포넌트에 사용)
     * + 배열값을 통해 인덱스를 바로 참조할 수 있도록 딕셔너리 제공
     */
    labelsetNameAndIndexList(): {
      labelsetNameList: string[];
      labelsetIndexDict: Record<string, number>;
    } {
      const labelsetIndexDict: Record<string, number> = {};
      const labelsetNameList = this.labelsetList.map((l, idx) => {
        const nameId = `${l.name}(${l.labelsetId?.slice(0, 4)})`;
        labelsetIndexDict[nameId] = idx;
        return nameId;
      });

      return { labelsetNameList, labelsetIndexDict };
    },
    prevTimelineNodeSettingIndex(): number {
      if (this.prevTimelineNodeSettingKey === '') return -1;
      return this.labelsetNameAndIndexList.labelsetIndexDict[
        this.prevTimelineNodeSettingKey
      ];
    },
    nextTimelineNodeSettingIndex(): number {
      if (this.nextTimelineNodeSettingKey === '') return -1;
      return this.labelsetNameAndIndexList.labelsetIndexDict[
        this.nextTimelineNodeSettingKey
      ];
    },
    currentTimeline():
      | {
          qualityGoalId: string;
          nextNode: string;
          previousNode: string;
        }
      | undefined {
      if (!this.labelset.reportTimelineList) return undefined;

      const found = this.labelset.reportTimelineList.find(
        (r) => r.qualityGoalId === this.localQualityGoal?.qualityGoalId,
      );

      return found;
    },
    hasNodes(): [boolean, boolean] {
      if (!this.currentTimeline) return [false, false];
      return [
        this.currentTimeline.previousNode !== '',
        this.currentTimeline.nextNode !== '',
      ];
    },
    urlLabelsetId(): string {
      return this.$route.path.split('/')[6];
    },
  },
  watch: {
    qualityGoal: {
      handler(newVal) {
        if (!newVal) {
          this.$router.push(`${this.$route.path}`);
        } else
          this.$router.push(
            `${this.$route.path}?pageNum=${1}&qid=${newVal.qualityGoalId}`,
          );
      },
      deep: true,
    },
    labelset: {
      handler() {
        this.$emit('refreshLabelset');
      },
    },
    urlLabelsetId: {
      async handler() {
        if (this.currentLabelsetId !== this.urlLabelsetId) {
          // 브라우저의 앞으로/뒤로가기 버튼을 통해 타임라인을 이동할 시 Labelset이 업데이트 되지 않는 경우를 처리
          this.$store.commit('startLoading');
          try {
            this.currentLabelsetId = this.urlLabelsetId;
            this.labelset = await getLabelsetById(this.currentLabelsetId);
          } catch (error) {
            console.error(error);
            alert('타임라인을 이동하는 중 오류가 발생했습니다.');
          }
          this.$store.commit('stopLoading');
        }
      },
    },
  },
  methods: {
    nextPage() {
      this.$router.push(
        `${this.$route.path}?pageNum=${Math.min(
          this.maxPageNum,
          this.currentPageNum + 1,
        )}&qid=${this.localQualityGoal?.qualityGoalId}`,
      );
    },
    prevPage() {
      this.$router.push(
        `${this.$route.path}?pageNum=${Math.max(
          1,
          this.currentPageNum - 1,
        )}&qid=${this.localQualityGoal?.qualityGoalId}`,
      );
    },
    async openSettingModal() {
      this.$store.commit('startLoading');

      this.labelsetList = await getAllLabelsetByWorkspaceId(
        this.$route.params.workspaceId,
      );

      const qualityGoalId = this.localQualityGoal?.qualityGoalId;
      const found = this.labelset.reportTimelineList?.find(
        (v) => v.qualityGoalId === qualityGoalId,
      );
      // 이미 사용 중인 타임라인 노드가 있을 경우 모달에 미리 적용
      if (found) {
        for (let i = 0; i < this.labelsetList.length; i++) {
          const csr = this.labelsetList[i];
          if (csr.labelsetId === found.previousNode) {
            this.prevTimelineNodeSettingKey = `${
              csr.name
            }(${csr.labelsetId.slice(0, 4)})`;
          }
          if (csr.labelsetId === found.nextNode) {
            this.nextTimelineNodeSettingKey = `${
              csr.name
            }(${csr.labelsetId.slice(0, 4)})`;
          }

          if (
            this.prevTimelineNodeSettingKey !== '' &&
            this.nextTimelineNodeSettingKey !== ''
          )
            break;
        }
      }

      this.$store.commit('stopLoading');
      this.isSettingModalVisible = true;
    },
    closeSettingModal() {
      this.prevTimelineNodeSettingKey = '';
      this.nextTimelineNodeSettingKey = '';

      this.isSettingModalVisible = false;
    },
    async postSettingModal() {
      // this.$store.commit('startLoading');
      // try {
      //   let newPrevNode =
      //     this.labelsetList[this.prevTimelineNodeSettingIndex]?.labelsetId ??
      //     '';
      //   newPrevNode =
      //     newPrevNode === this.labelset.labelsetId ? '' : newPrevNode;
      //   let newNextNode =
      //     this.labelsetList[this.nextTimelineNodeSettingIndex]?.labelsetId ??
      //     '';
      //   newNextNode =
      //     newNextNode === this.labelset.labelsetId ? '' : newNextNode;

      //   const newLabelset = await setReportTimeline(
      //     this.$route.params.labelsetId,
      //     this.localQualityGoal?.qualityGoalId ?? '',
      //     newPrevNode,
      //     newNextNode,
      //   );

      //   this.labelset = newLabelset;
      // } catch (error) {
      //   console.error(error);

      //   alert('설정을 저장하는 중 오류가 발생했습니다.');
      // }
      // this.$store.commit('stopLoading');

      this.isSettingModalVisible = false;
    },
    unsetPrevTimelineNodeSetting() {
      this.prevTimelineNodeSettingKey = '';
    },
    unsetNextTimelineNodeSetting() {
      this.nextTimelineNodeSettingKey = '';
    },
    async moveTimelinePrev() {
      if (!this.hasNodes[0]) {
        this.$toast('첫 페이지 입니다.');
        return;
      }

      this.$store.commit('startLoading');

      try {
        this.currentLabelsetId = this.currentTimeline?.previousNode ?? '';
        const newLabelset = await getLabelsetById(this.currentLabelsetId);

        const pathArray = this.$route.path.split('/');
        pathArray[4] = newLabelset.datasetId;
        pathArray[6] = newLabelset.labelsetId;

        await this.$router.push(
          `${pathArray.join('/')}?qid=${this.localQualityGoal?.qualityGoalId}`,
        );

        this.labelset = newLabelset;
      } catch (error) {
        console.error(error);
        alert('타임라인을 이동하는 중 오류가 발생했습니다.');
      }

      this.$store.commit('stopLoading');
    },
    async moveTimelineNext() {
      if (!this.hasNodes[1]) {
        this.$toast('마지막 페이지 입니다.');
        return;
      }

      this.$store.commit('startLoading');

      try {
        this.currentLabelsetId = this.currentTimeline?.nextNode ?? '';
        const newLabelset = await getLabelsetById(this.currentLabelsetId);

        const pathArray = this.$route.path.split('/');
        pathArray[4] = newLabelset.datasetId;
        pathArray[6] = newLabelset.labelsetId;

        await this.$router.push(
          `${pathArray.join('/')}?qid=${this.localQualityGoal?.qualityGoalId}`,
        );

        this.labelset = newLabelset;
      } catch (error) {
        console.error(error);
        alert('타임라인을 이동하는 중 오류가 발생했습니다.');
      }

      this.$store.commit('stopLoading');
    },
    async printReport() {
      if (!confirm('보고서를 PDF로 출력합니다.')) return;

      this.$store.commit('startLoading');

      const pdf = new jsPDF('p', 'mm', 'a4');
      const canvas = pdf.canvas;
      const paddingX = 10;
      const paddingY = 10;
      const pageWidth = 210 - paddingX * 2;
      const pageHeight = 295;
      canvas.width = pageWidth;

      const el = document.querySelector<HTMLElement>(
        '#report-area > *:first-child',
      );

      if (!el) return false;

      const elWidth = el.offsetWidth;
      const elHeight = el.offsetHeight;
      const imgHeight = (pageWidth * elHeight) / elWidth + 2 * 3.78 * paddingY;

      const resultCanvas = await html2canvas(el, {
        allowTaint: true,
        useCORS: true,
        logging: false,
        height: el.scrollHeight,
        windowHeight: el.scrollHeight,
      });

      let position = 0;

      const imgData = resultCanvas.toDataURL('image/png');

      pdf.addImage(
        imgData,
        'png',
        paddingX,
        position + paddingY,
        pageWidth,
        imgHeight,
        undefined,
        'SLOW',
      );

      // paging
      let heightLeft = imgHeight;
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(
          imgData,
          'png',
          paddingX,
          position + paddingY,
          pageWidth,
          imgHeight,
        );
        heightLeft -= pageHeight;
      }

      pdf.save(this.qualityGoal.name.toLowerCase() + '.pdf');

      this.$store.commit('stopLoading');
    },
  },
  components: {
    Button,
    ConfigureButton,
    SyntaxErrorGoalReport,
    TotalDataQuantityGoalReport,
    DistributionGoalReport,
    QuantityGoalReport,
    MinAvgMaxGoalReport,
    ArrLenMinAvgMaxGoalReport,
    TotalElementCountReport,
    SummaryReport,
    Modal,
    CustomSelect,
    DeleteButton,
  },
});
